import { render, staticRenderFns } from "./LynusPopup.vue?vue&type=template&id=5f07aaf3&scoped=true&"
import script from "./LynusPopup.vue?vue&type=script&lang=ts&"
export * from "./LynusPopup.vue?vue&type=script&lang=ts&"
import style0 from "./LynusPopup.vue?vue&type=style&index=0&id=5f07aaf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07aaf3",
  null
  
)

export default component.exports